import {useDispatch, useSelector} from "react-redux";
import {getLowestFixed, getLowestVariable, getWhitelabelId} from "store/selectors/whitelabel";
import {TextType, SaaSWelcomePage as SaaSWelcomePageUI} from "@pinch-financial/pinch-ui-components";
import NavigationBar from "components/NavigationBar/NavigationBar";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import usePageText from "hooks/usePageText";
import {useTheme} from "@mui/material";
import useOnResize from "~/hooks/useOnResize/useOnResize";
import {getIsSaaSWelcomeEnabled} from "~/store/selectors/navigationController";
import {getIsOperationPending} from "~/store/selectors/operation";
import {OperationType} from "~/types/operation";
import {getLowestRate} from "./SaaSWelcomePage.action";
import {isCurrentFrench} from "~/util/languageUtil";


interface Props {
  onNextPage?: () => any;
  containerRef?: React.RefObject<HTMLDivElement>;
}

const SaaSWelcomePage = ({onNextPage, containerRef}: Props) => {
  const {t} = useTranslation("", {keyPrefix: "saasWelcomePage"});
  const {getText, status: textStatus, isTipBoxEnabled} = usePageText("SAAS_LANDING_PAGE_URL");

  const dispatch = useDispatch();
  const isFetchingLowestRate = useSelector(getIsOperationPending)(OperationType.fetchLowestRate);

  const theme = useTheme();
  const {isScreenMobileWidth} = useOnResize(theme.breakpoints);

  const saasWelcome = useSelector(getIsSaaSWelcomeEnabled);
  const whiteLabelId = useSelector(getWhitelabelId);
  const lowestFixed = useSelector(getLowestFixed);
  const lowestVariable = useSelector(getLowestVariable);

  useEffect(() => {
    if (saasWelcome && whiteLabelId && !(lowestFixed || lowestVariable)) {
      dispatch(getLowestRate(whiteLabelId));
    }
  }, [saasWelcome, whiteLabelId])

  return (
    <SaaSWelcomePageUI
      containerRef={containerRef}
      loading={textStatus === "not-started" || textStatus === "pending"}
      header={getText(TextType.APP_PAGE_HEADER) ?? t("header")}
      body1={getText(TextType.APP_PAGE_BODY) ?? t("body1")}
      body2={getText(TextType.APP_PAGE_BODY2) ?? t("body2")}
      tipHeader={isTipBoxEnabled ? getText(TextType.APP_PAGE_TIP_HEADER) ?? t("tipHeader") : ""}
      tipBody={isTipBoxEnabled ? getText(TextType.APP_PAGE_TIP_BODY) ?? t("tipBody") : ""}
      nextButtonText={getText(TextType.APP_PAGE_NEXT_BUTTON) ?? t("nextButton")}
      onNextPage={onNextPage}
      navigationBar={<NavigationBar />}
      iconAlt={t("iconAlt")}
      isScreenMobileWidth={isScreenMobileWidth}
      isFrench={isCurrentFrench()}
      ratesFrom={t("ratesFrom")}
      yearFixed={t("yearFixed")}
      yearVariable={t("yearVariable")}
      isFetchingLowestRate={isFetchingLowestRate}
      lowestFixed={lowestFixed}
      lowestVariable={lowestVariable}
    />
  )
};

export default SaaSWelcomePage;
